import { motion } from "framer-motion";
import { QuizQuestion } from "@shared/types";
import { Check } from "lucide-react";

interface SingleChoiceProps {
  question: QuizQuestion;
  value: string;
  onChange: (value: string) => void;
  onAutoAdvance?: (value: any) => void;
}

export default function SingleChoice({
  question,
  value,
  onChange,
  onAutoAdvance,
}: SingleChoiceProps) {
  const handleSelect = (optionValue: string) => {
    onChange(optionValue);
    if (onAutoAdvance) {
      onAutoAdvance(optionValue);
    }
  };
  return (
    <div className="space-y-2">
      {question.options?.map((option, index) => {
        const isSelected = value === option.value;

        return (
          <button
            key={index}
            onClick={() => handleSelect(option.value)}
            disabled={option.disabled}
            className={`
              w-full p-4 rounded-xl text-left transition-all
              ${isSelected ? "select-option-selected" : "select-option"}
              ${
                option.disabled
                  ? "opacity-50 cursor-not-allowed"
                  : "cursor-pointer"
              }
            `}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                {option.emoji && (
                  <span className="text-2xl">{option.emoji}</span>
                )}
                <span className="font-medium">
                  {option.label}
                  {option.disabled && (
                    <span className="text-xs text-dark-muted ml-2">
                      (Coming soon)
                    </span>
                  )}
                </span>
              </div>
              {isSelected && (
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center"
                >
                  <Check className="w-4 h-4 text-white" />
                </motion.div>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
}
